import { render, staticRenderFns } from "./NewsLayout.vue?vue&type=template&id=02c979f4&lang=pug"
import script from "./NewsLayout.vue?vue&type=script&lang=js"
export * from "./NewsLayout.vue?vue&type=script&lang=js"
import style0 from "./NewsLayout.vue?vue&type=style&index=0&id=02c979f4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports